import { Component } from '@angular/core';
import { Instagram } from '@ionic-native/instagram';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavParams, ToastController } from 'ionic-angular';
import { Observable, Observer } from 'rxjs';
import { UserProvider } from '../../../providers/user/user';

@Component({
    selector: 'page-success-payment',
    templateUrl: 'success-payment.html',
})
export class SuccessPaymentPage {
    imageUrl;
    token;

    constructor(
        private navParams: NavParams,
        private instagram: Instagram,
        private loadingCtrl: LoadingController,
        private userService: UserProvider) {
        this.imageUrl = this.navParams.get("image");
        this.token = this.navParams.get("token");
        this.onPost();
        this.addNewPicture();
    }

    addNewPicture() {
        let loader = this.loadingCtrl.create({ content: 'loading' });
        loader.present();
        let base64Image = "";
        this.getBase64ImageFromURL(this.imageUrl).subscribe(base64data => {
            base64Image = 'data:image/jpeg;base64,' + base64data;
            this.userService.createPhotoWithToken(-1, base64Image, this.token).then(data => {
                console.log('success upload: ', data);
                loader.dismiss();
            });
        });
    }

    onShare() {
        this.onPost()
    }

    onPost() {
        let base64Image = "";
        this.getBase64ImageFromURL(this.imageUrl).subscribe(base64data => {
            console.log(base64data);
            base64Image = 'data:image/jpeg;base64,' + base64data;

            this.instagram.share(base64Image);
        });
    }

    getBase64ImageFromURL(url: string) {
        return Observable.create((observer: Observer<string>) => {
            let img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = url;
            if (!img.complete) {
                img.onload = () => {
                    observer.next(this.getBase64Image(img));
                    observer.complete();
                };
                img.onerror = (err) => {
                    observer.error(err);
                };
            } else {
                observer.next(this.getBase64Image(img));
                observer.complete();
            }
        });
    }

    getBase64Image(img: HTMLImageElement) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
    }
}



// WEBPACK FOOTER //
// /src/pages/payment-system/success-payment/success-payment.ts